<template>
  <v-sheet min-height="100%" rounded outlined class="pa-6">
    <div v-if="work && Object.keys(work).length">
      <h4 class="py-2">Work Preview</h4>

      <v-img
          v-if="!imageChanged && work.image"
          :src="work.image_src"
          max-height="200"
          contain
      />

      <v-img
          v-if="imageChanged"
          :src="imagePreview"
          max-height="200"
          contain
      />

      <div class="mt-4">
        <h3>{{ work?.name }}</h3>

        <p style="white-space: pre-line;">
          {{ work?.description }}
        </p>

        <p>
          {{ work?.price }}
          {{ work?.currency }}
          ({{ priceSpecLabel(work?.price_spec) }})
        </p>

        <p v-if="work?.discount">
          Discount: {{ work.discount }}%
        </p>
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    work: {
      type: Object,
      required: true
    },
    imageChanged: Boolean,
    imagePreview: String,
    priceSpecs: {
      type: Array,
      required: true
    }
  },

  methods: {
    priceSpecLabel(value) {
      const found = this.priceSpecs.find(p => p.value == value);
      return found ? found.label : "";
    }
  }
};
</script>
